import * as actionTypes from "../actions/actionTypes";
import { ClientState } from "./types";

const initState: ClientState = {
  isInitSuccessful: true,
};

const reducer = (state: ClientState = initState, action): ClientState => {
  switch (action.type) {
    case actionTypes.ERROR_INIT_CLIENT:
      return { ...state, isInitSuccessful: false };
    default:
      return state;
  }
};

export default reducer;
